import { Component } from '@angular/core';

import { VersionChange, VersionService } from './core';

@Component({
    selector: 'ag-dashboard-root',
    template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
    constructor(versionService: VersionService) {
        versionService.listenToVersionChanges(VersionChange.MAJOR, () => window.location.reload());
    }
}
